export const CREDITOPTION_LOADING = "CREDITOPTION_LOADING";
export const CREDITOPTION_RESET = "CREDITOPTION_RESET";
export const GET_CREDITOPTION = "GET_CREDITOPTION";
export const GET_CREDITOPTION_SUCCESS = "GET_CREDITOPTION_SUCCESS";
export const GET_CREDITOPTION_FAIL = "GET_CREDITOPTION_FAIL";
export const DELETE_CREDITOPTION = "DELETE_CREDITOPTION"
export const DELETE_CREDITOPTION_SUCCESS = "DELETE_CREDITOPTION_SUCCESS"
export const DELETE_CREDITOPTION_FAIL = "DELETE_CREDITOPTION_FAIL"
export const UPDATE_CREDITOPTION = "UPDATE_CREDITOPTION"
export const UPDATE_CREDITOPTION_SUCCESS = "UPDATE_CREDITOPTION_SUCCESS"
export const UPDATE_CREDITOPTION_FAIL = "UPDATE_CREDITOPTION_FAIL"
export const ADD_NEW_CREDITOPTION = "ADD_NEW_CREDITOPTION"
export const ADD_CREDITOPTION_SUCCESS = "ADD_CREDITOPTION_SUCCESS"
export const ADD_CREDITOPTION_FAIL = "ADD_CREDITOPTION_FAIL"